/* eslint-disable no-useless-catch */
import { API } from "../api";

const TPL_INVOICES_URL = "/tpl-invoices";

export const GET_TPL_INVOICES_LIST = "GET_TPL_INVOICES_LIST";

export const getTPLInvoices = (filter = {}) => {
  return async (dispatch) => {
    try {
      const res = await API.post(TPL_INVOICES_URL, filter);
      dispatch({
        type: GET_TPL_INVOICES_LIST,
        payload: res,
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

const initialState = {
  columns: [],
  rows: [],
  totalRows: 0,
};

export default function reducer(state = initialState, { type, payload }) {
  switch (type) {
    case GET_TPL_INVOICES_LIST:
      return {
        ...state,
        columns: payload?.columns || [],
        rows: payload?.rows || [],
        totalRows: payload?.count || 0,
      };
    default:
      return state;
  }
}
